<template>
  <div class="orlist">
    <headd :mobile_title="mobile_title"></headd>

    <div class="order_list container">
      <div class="coupon_title hidden-sm hidden-xs">我的订单</div>
      <el-tabs stretch="true" v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="全部" name="1"> </el-tab-pane>
        <el-tab-pane label="待付款" name="2"> </el-tab-pane>
        <el-tab-pane label="待处理" name="3"> </el-tab-pane>
        <el-tab-pane label="办理中" name="4"> </el-tab-pane>
        <el-tab-pane label="已完结" name="5"> </el-tab-pane>
      </el-tabs>
      <div class="list" v-if="orderlist.length > 0">
        <div
          class="item"
          v-for="item in orderlist"
          :key="item.id"
          @click="goorderdetail(item.id)"
        >
          <div class="item_head">
            <div class="head_info">
              <div class="info_icon">
                <img src="../../../static/order/icon_type_1.png" />
              </div>
              <div class="info_type">{{ item.ctitle }}</div>
            </div>
            <div
              class="head_status status2"
              v-if="item.order_status == 'unpay'"
            >
              待付款
            </div>
            <div
              class="head_status status1"
              v-if="item.order_status == 'pending'"
            >
              待处理
            </div>
            <div
              class="head_status status1"
              v-if="item.order_status == 'processing'"
            >
              办理中
            </div>
            <div
              class="head_status status3"
              v-if="item.order_status == 'success'"
            >
              已完结
            </div>
            <div
              class="head_status status3"
              v-if="item.order_status == 'closed'"
            >
              已关闭
            </div>
          </div>
          <div class="info">
            <div class="name">{{ item.title }}</div>
            <div class="option" v-if="item.option || item.otheroption">
              <div class="title">选项:</div>
              <div class="content">
                <!-- <block v-for="item_2 in item.option">
							<view>{{item_2.key}}：{{item_2.value}}</view></block> -->
                <div>{{ item.option }}</div>
                <div>{{ item.otheroption }}</div>
              </div>
            </div>
            <div class="option">
              <div class="title">订单号:</div>
              <div class="content">
                <div>{{ item.out_trade_no }}</div>
              </div>
            </div>
            <div class="option">
              <div class="title">订单金额:</div>
              <div class="content">
                <div>{{ item.order_price }} 元</div>
              </div>
            </div>
            <div class="price">
              付款金额:<span class="span">{{ item.pay_price }} 元</span>
            </div>
          </div>
          <div class="btn_detail" @click="goorderdetail(item.id)">查看详情</div>
        </div>
      </div>

      <div class="list_nodata" v-else>
        <div class="nodata_icon">
          <img src="../../../static/order/icon_6.png" />
        </div>
        <div class="nodata_text">未查询到订单</div>
      </div>
      <div class="gomore" @click="morelist" v-show="!flag">加载更多</div>
    </div>
    <foot></foot>
  </div>
</template>

<script>
import { getmyOrder } from "../api/api"; //引入api里面定义的方法
import headd from "@/components/head";
import foot from "@/components/foot";
export default {
  data() {
    return {
      mobile_title: "我的订单",
      current: 0,
      activeName: "1",
      tabs: ["全部", "待付款", "待处理", "办理中", "已完结"],
      orderstatus_type: [
        "",
        "unpay",
        "pending",
        "processing",
        "success",
        "closed"
      ],
      orderlist: [],
      pageindex: 1,
      flag: false,
      orderstatus: ""
    };
  },
  components: { headd, foot },
  onLoad(options) {
    var _self = this;
    if (options.index) {
      _self.orderstatus = _self.orderstatus_type[options.index];
      _self.current = parseInt(options.index);
    }
  },
  mounted() {
    var _self = this;
    if (this.$route.query.index) {
      console.log(_self.orderstatus_type[this.$route.query.index - 1]);
      _self.orderstatus = _self.orderstatus_type[this.$route.query.index - 1];
      _self.activeName = this.$route.query.index;
    }
    this.getorderlist();
    //console.log(this.$route.query.index);
  },
  methods: {
    handleClick(tab, event) {
      var index = parseInt(tab.name);
      var _self = this;
      _self.orderstatus = _self.orderstatus_type[index - 1];
      _self.orderlist = [];
      _self.pageindex = 1;
      _self.flag = false;
      _self.getorderlist();
    },
    goorderdetail(id) {
      this.$router.push({
        path: "orderdetail",
        query: {
          id: id
        }
      });
    },
    async getorderlist() {
      var _slef = this;
      var data = {
        uid: localStorage.getItem("userId"),
        orderstatus: _slef.orderstatus,
        page: _slef.pageindex,
        limit: 10
      };
      const res = await getmyOrder(data);

      _slef.orderlist = _slef.orderlist.concat(res.data.data.myorders);

      if (res.data.data.myorders.length < 10) {
        _slef.flag = true;
      }
    },
    morelist() {
      if (!this.flag) {
        this.pageindex++;
        this.getorderlist();
      }
    }
  },
  onShow() {
    this.orderlist = [];
    this.pageindex = 1;
    (this.flag = false), this.getorderlist();
    this.$logindex();
  },
  onReachBottom() {
    if (!this.flag) {
      this.pageindex++;
      this.getorderlist();
    }
  },
  onPullDownRefresh() {
    console.log("下拉刷新了");
    this.pageindex = 1;
    this.orderlist = [];
    this.flag = false;
    setTimeout(() => {
      this.getorderlist(() => {
        uni.stopPullDownRefresh();
      });
    }, 1000);
  }
};
</script>

<style lang="less" scoped>
.orlist {
  @media (max-width: 991px) {
    width: 6.86rem;
    margin: auto;
    .container {
      padding: 0;
    }
  }
}
.order_list {
  flex-direction: column;
  width: 8rem;
  @media (max-width: 991px) {
    width: 100%;
    margin-top: 0;
  }
  margin-top: 0.3rem;
  .coupon_title {
    font-size: 0.26rem;
    margin-bottom: 0.32rem;
    text-align: left;
  }

  .list {
    margin: 0.32rem 0;
    flex-direction: column;
    .item {
      height: auto;
      background: #ffffff;
      box-shadow: 0px 0.01rem 0.1rem 0.01rem rgba(132, 132, 132, 0.12);
      border-radius: 0.22rem;
      margin-bottom: 0.3rem;
      padding: 0.2rem 0.2rem 0.3rem 0.2rem;
      flex-direction: column;
      position: relative;

      .item_head {
        border-bottom: 0.01rem solid rgba(196, 196, 204, 0.5);
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        padding: 0.22rem 0;
        height: auto;

        .head_info {
          display: flex;
          align-items: center;
          .info_icon {
            width: 0.28rem;
            height: 0.26rem;
            margin-right: 0.11rem;

            img {
              width: 100%;
              height: 100%;
            }
          }

          .info_type {
            font-size: 0.2rem;
            color: #1b1c33;
            line-height: 0.25rem;
          }
        }

        .head_status {
          width: 0.96rem;
          height: 0.38rem;
          border-radius: 0.2rem;
          font-size: 0.16rem;
          text-align: center;
          line-height: 0.38rem;
          align-items: center;
          justify-content: center;
        }

        .head_status.status1 {
          border: 1px solid #1395ff;
          color: #1395ff;
        }

        .head_status.status2 {
          border: 1px solid #ff545a;
          color: #ff545a;
        }

        .head_status.status3 {
          border: 1px solid #8d8e99;
          color: #8d8e99;
        }
      }

      .info {
        flex-direction: column;
        text-align: left;

        .name {
          font-size: 0.24rem;
          font-weight: bolder;
          color: #1b1c33;
          line-height: 0.33rem;
          margin-bottom: 0.2rem;
          margin-top: 0.2rem;
        }

        .option {
          flex-direction: row;
          margin-bottom: 0.1rem;
          display: flex;
          .title {
            font-size: 0.16rem;
            color: #8d8e99;
            line-height: 0.25rem;
            width: 0.96rem;
          }

          .content {
            flex-direction: column;
            font-size: 0.16rem;
            color: #444649;
            line-height: 0.25rem;

            view {
              margin-bottom: 0.15rem;
              &:last-child {
                margin-bottom: 0;
              }
            }
          }
          &:last-child {
            margin-bottom: 0;
          }
        }

        .price {
          margin-top: 0.21rem;
          font-size: 0.16rem;
          font-weight: bolder;
          color: #1b1c33;
          line-height: 0.25rem;
          .span {
            margin-left: 0.1rem;
            color: #ff545a;
          }
        }
      }

      .btn_detail {
        position: absolute;
        bottom: 0.3rem;
        right: 0.2rem;
        width: 0.96rem;
        height: 0.38rem;
        background: #1395ff;
        border-radius: 0.2rem;
        text-align: center;
        justify-content: center;
        align-items: center;
        font-size: 0.16rem;
        color: #ffffff;
        line-height: 0.4rem;
        cursor: pointer;
      }
    }
  }

  .list_nodata {
    margin: 1rem 0;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .nodata_icon {
      width: 3.83rem;
      height: 2.72rem;
      margin: 0rem auto 0.3rem auto;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .nodata_text {
      font-size: 0.2rem;
      color: #8d8e99;
      line-height: 0.3rem;
      letter-spacing: 0.01rem;
      @media (max-width: 991px) {
        font-size: 0.28rem;
      }
    }
  }

  @media (max-width: 991px) {
    width: 100%;
    flex-direction: column;

    .list {
      margin: 0.32rem 0;
      flex-direction: column;
      .item {
        width: 6.86rem;
        height: auto;
        background: #ffffff;
        box-shadow: 0px 0.01rem 0.1rem 0.01rem rgba(132, 132, 132, 0.12);
        border-radius: 0.22rem;
        margin-bottom: 0.3rem;
        padding: 0.2rem 0.2rem 0.3rem 0.2rem;
        flex-direction: column;
        position: relative;

        .item_head {
          border-bottom: 0.02rem solid rgba(196, 196, 204, 0.5);
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          width: 100%;
          padding: 0.22rem 0;
          height: 0.72rem;

          .head_info {
            display: flex;
            align-items: center;
            .info_icon {
              display: flex;
              width: 0.28rem;
              height: 0.26rem;
              margin-right: 0.11rem;

              img {
                width: 100%;
                height: 100%;
              }
            }

            .info_type {
              font-size: 0.3rem;
              color: #1b1c33;
              line-height: 0.3rem;
            }
          }

          .head_status {
            width: 1.26rem;
            height: 0.38rem;
            border-radius: 0.2rem;
            font-size: 0.24rem;
            text-align: center;
            line-height: 0.38rem;
            align-items: center;
            justify-content: center;
          }

          .head_status.status1 {
            border: 1px solid #1395ff;
            color: #1395ff;
          }

          .head_status.status2 {
            border: 1px solid #ff545a;
            color: #ff545a;
          }

          .head_status.status3 {
            border: 1px solid #8d8e99;
            color: #8d8e99;
          }
        }

        .info {
          flex-direction: column;

          .name {
            font-size: 0.3rem;

            font-weight: bolder;
            color: #1b1c33;
            line-height: 0.42rem;
            margin-bottom: 0.2rem;
            margin-top: 0.2rem;
          }

          .option {
            flex-direction: row;
            margin-bottom: 0.2rem;
            .title {
              font-size: 0.28rem;
              color: #8d8e99;
              line-height: 0.37rem;
              width: 1.28rem;
            }

            .content {
              flex-direction: column;
              font-size: 0.28rem;
              color: #444649;
              line-height: 0.37rem;

              view {
                margin-bottom: 0.15rem;
                &:last-child {
                  margin-bottom: 0;
                }
              }
            }
            &:last-child {
              margin-bottom: 0;
            }
          }

          .price {
            margin-top: 0.21rem;
            font-size: 0.3rem;

            font-weight: bolder;
            color: #1b1c33;
            line-height: 0.42rem;
            .span {
              margin-left: 0.1rem;
              color: #ff545a;
            }
          }
        }

        .btn_detail {
          position: absolute;
          bottom: 0.3rem;
          right: 0.2rem;
          width: 1.26rem;
          height: 0.4rem;
          background: #1395ff;
          border-radius: 0.2rem;
          text-align: center;
          justify-content: center;
          align-items: center;
          font-size: 0.24rem;

          color: #ffffff;
          line-height: 40rpx;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/order/order_list.vue